import styled from "styled-components";

export const Container = styled.div`
    width:100%;
  .container{
    width:100%;
    //.imageUploader{
    //  margin: auto 20px;
    //}
  }
   


`
